
const FONT = (size) => `${size}px "DM Sans", ui-sans-serif, system-ui, sans-serif`;

let ctx = null;
function measurer() {
  if (ctx !== null) return ctx;
  try {
    ctx = document.createElement("canvas").getContext("2d");
  } catch {
    ctx = false;
  }
  return ctx;
}

export function measureText(text, fontSize) {
  const c = measurer();
  if (c) {
    c.font = FONT(fontSize);
    const w = c.measureText(text).width;
    if (w > 0) return w;
  }
  return String(text).length * fontSize * 0.52;
}

export function wrapText(text, maxWidth, fontSize) {
  const source = String(text ?? "");
  if (!source) return [""];
  if (maxWidth <= 0) return source.split("\n");

  const lines = [];
  for (const paragraph of source.split("\n")) {
    if (!paragraph) { lines.push(""); continue; }

    let line = "";
    for (const word of paragraph.split(/\s+/).filter(Boolean)) {
      const candidate = line ? `${line} ${word}` : word;
      if (measureText(candidate, fontSize) <= maxWidth || !line) {
        if (!line && measureText(word, fontSize) > maxWidth) {
          let chunk = "";
          for (const ch of word) {
            if (measureText(chunk + ch, fontSize) > maxWidth && chunk) {
              lines.push(chunk);
              chunk = ch;
            } else {
              chunk += ch;
            }
          }
          line = chunk;
        } else {
          line = candidate;
        }
      } else {
        lines.push(line);
        line = word;
      }
    }
    lines.push(line);
  }
  return lines.length ? lines : [""];
}

export const LINE_HEIGHT = 1.35;

export function textHeight(text, maxWidth, fontSize) {
  return wrapText(text, maxWidth, fontSize).length * fontSize * LINE_HEIGHT;
}
